import React, { createContext, useContext, useState, MutableRefObject } from 'react';

interface ScrollPositionContextValue {
    scrollContainerRef: MutableRefObject<HTMLDivElement | null>;
    savePosition: (key: string, value: number) => void;
    getPosition: (key: string) => number;
}

const ScrollPositionContext = createContext<ScrollPositionContextValue | undefined>(undefined);

interface ScrollProviderProps {
    scrollContainerRef: MutableRefObject<HTMLDivElement | null>;
    children: React.ReactNode;
}

export const ScrollPositionProvider: React.FC<ScrollProviderProps> = ({ scrollContainerRef, children }) => {
    const [positions, setPositions] = useState<Record<string, number>>({});

    const savePosition = (key: string, value: number) => {
        setPositions((prev) => ({ ...prev, [key]: value }));
    };

    const getPosition = (key: string) => positions[key];

    return (
        <ScrollPositionContext.Provider value={{ scrollContainerRef, savePosition, getPosition }}>
            {children}
        </ScrollPositionContext.Provider>
    );
};

export const useScrollPosition = () => {
    const context = useContext(ScrollPositionContext);
    if (!context) {
        throw new Error('useScrollPosition must be used within a ScrollPositionProvider');
    }

    return {
        savePosition: context.savePosition,
        getPosition: context.getPosition,
    };
};
